import type { IMosaicTocExpanded, ITocActionUpdateCommentsFilter } from "./interface";

/**
 * Updates the comment-visibility filter used by the ToC.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the new comments filter.
 * @returns The updated ToC state with the comments filter applied.
 */
export const toc_updateCommentsFilter = (
  state: IMosaicTocExpanded,
  action: ITocActionUpdateCommentsFilter,
): IMosaicTocExpanded => ({
  ...state,
  commentsFilter: action.commentsFilter,
});
